import { useEffect } from 'react';
import moment from 'moment';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import socialMedia from 'root/src/shared/constants/socialMedia';
import { EMAIL } from 'root/src/shared/constants/pageData';
import { DiscordIcon } from 'root/src/client/v2/common/components/icons/DiscordIcon';
import { Button, buttonVariants } from 'root/src/client/v2/common/components/ui/button';
import { RedesignErrorCard } from 'root/src/client/v2/_pages/error/redesign/RedesignErrorCard';
import { RedesignStandaloneErrorShell } from 'root/src/client/v2/_pages/error/redesign/RedesignStandaloneErrorShell';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// How often the screen reloads itself while the user sits on it, kept at the legacy TechIssueComponent
// value: the outage is usually a deploy or a cold backend, so a retry a few seconds later tends to land.
const AUTO_REFRESH_MS = 10000;
const refresh = () => window.location.reload();
// Redesign twin of `TechIssueComponent`: the technical-difficulties screen behind `/500` and behind
// every ErrorBoundary in `_app`. The legacy component stays in place, just no longer mounted.
//
// It renders through RedesignStandaloneErrorShell (no navbar, no providers) because both of its mount
// points are outside the app providers, see that file.
export const RedesignTechIssuePage = ({ timestamp }) => {
    useEffect(() => {
        const interval = setInterval(refresh, AUTO_REFRESH_MS);
        return () => clearInterval(interval);
    }, []);
    return (<RedesignStandaloneErrorShell>
			<RedesignErrorCard icon={<ReportProblemOutlinedIcon sx={{ fontSize: 26 }}/>} iconTileClassName="bg-destructive/15 text-destructive" title="We're experiencing technical difficulties" actions={(<>
						<Button variant="brand" onClick={refresh}>
							<RefreshOutlinedIcon />
							Refresh the page
						</Button>
						<a href={`mailto:${EMAIL}`} className={cn(buttonVariants({ variant: 'outline' }), 'no-underline')}>
							<MailOutlineIcon />
							Contact support
						</a>
						<a href={socialMedia.discord} target="_blank" rel="noopener noreferrer" className={cn(buttonVariants({ variant: 'outline' }), 'no-underline')}>
							<DiscordIcon />
							Discord
						</a>
					</>)}>
				<p>
					{timestamp ? `Something broke on our side (as of ${moment(timestamp).format('h:mmA')}). ` : 'Something broke on our side. '}
					This page retries on its own every few seconds, so give it a moment or refresh manually.
				</p>
				<p>If it keeps happening, reach out and we will take a look.</p>
			</RedesignErrorCard>
		</RedesignStandaloneErrorShell>);
};
